import PublicBookingForm from '@bookings/components/public-booking-form/public-booking-form.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-new-booking',
  components: {
    'bpc-public-booking-form': PublicBookingForm,
  },
})
export default class ProfileNewBooking extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
